(function () {
  'use strict';

  var observer;
  var moving = false;

  function getRows() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.cart-page .cart-items__table-row--tally-preview')
    );
  }

  function getUnassignedPreviews() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.cart-page .tally-image-product-container')
    ).filter(function (preview) {
      return !preview.closest('.pv-cart-artwork-slot');
    });
  }

  function placeTallyPreviews() {
    if (moving) return;
    moving = true;

    try {
      var rows = getRows();
      if (!rows.length) return;

      var unassigned = getUnassignedPreviews();

      rows.forEach(function (row) {
        var slot = row.querySelector('.pv-cart-artwork-slot');
        if (!slot) return;

        var preview = row.querySelector('.tally-image-product-container');

        /* If Tally rendered the preview outside this cart row, pair the next
           unassigned Tally preview with this custom-sticker line item. */
        if (!preview || preview.closest('.pv-cart-artwork-slot')) {
          preview = unassigned.shift() || slot.querySelector('.tally-image-product-container');
        }

        if (!preview) return;

        if (!slot.contains(preview)) {
          slot.appendChild(preview);
        }

        preview.classList.add('pv-tally-cart-preview');
        row.classList.add('pv-cart-layout-ready');
      });
    } finally {
      moving = false;
    }
  }

  function schedule() {
    window.requestAnimationFrame(placeTallyPreviews);
    window.setTimeout(placeTallyPreviews, 120);
    window.setTimeout(placeTallyPreviews, 500);
    window.setTimeout(placeTallyPreviews, 1200);
    window.setTimeout(placeTallyPreviews, 2500);
  }

  function start() {
    schedule();

    var target = document.querySelector('.cart-page') || document.body;
    if (!target || observer) return;

    observer = new MutationObserver(function () {
      schedule();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', schedule, { once: true });
})();
